import * as yup from "yup";
import { FISCAL_CODE_REG_EXP, ITALY_CODE, FRANCE_CODE, SPAIN_CODE, FISCAL_CODE_REG_EXP_ES, FISCAL_CODE_REG_EXP_PT, PORTUGAL_CODE } from "../../config";
import { IRaFillingForm } from "../../models/models";
import { getRequiredVatNr, validateVatNr } from "../../utils";

export enum AncillarySubtype {
	Delivery = 'DELIVERY',
	Collection = 'COLLECTION',
	AfterhourPickup = 'AFTERHOUR_PICKUP',
	AfterhourDropoff = 'AFTERHOUR_DROPOFF',
	OneWay = 'ONE_WAY',
	StandardCover = 'STANDARD_COVER',
	SuperCover = 'SUPER_COVER',
	// LPP-22290 / Requirement 5.1: coperture indipendenti riduzione franchigia danno (SCDW) e furto (STP).
	Scdw = 'SCDW',
	Stp = 'STP',
	None = 'NONE',
	AdditionalDrivers = 'ADDITIONAL_DRIVER',
	UrbanCollection = 'URBAN_COLLECTION',
	UrbanDelivery = 'URBAN_DELIVERY',
	Keyless = 'KEYLESS',
}

/**
 * LPP-22293 / US-NTWRA-005 (RDT §2.1, §2.10) — criterio di raggruppamento del servizio
 * "Change Group" come costante/pattern FE (Requirement 4).
 *
 * Il Change Group è modellato a backend come N ancillary distinte (`type=Accessory`,
 * `subtype=NONE`) con `ancillaryCode` = `CG{importo}` (i "7 box": CG5/CG10/CG20/CG25/
 * CG50/CG75/CG100). NON esiste un marcatore strutturale (nessun subtype/type dedicato):
 * il criterio di raggruppamento è quindi una costante FE, unico punto di verità, NON
 * editabile a runtime dal BU (aggiornabile solo via rilascio).
 *
 * Criterio primario: `ancillaryCode` che matcha `^CG\d+$`.
 * Criterio subordinato (fallback): `name` che inizia con "Change Group".
 */
export const CHANGE_GROUP_CODE_PATTERN = /^CG\d+$/;
export const CHANGE_GROUP_NAME_PREFIX = 'Change Group';

export const RA_FILLING_FORM_INITIAL_VALUE: IRaFillingForm = {
	generalInfo: {
		pickupLocation: null,
		expectedPickupDateTime: null,
		dropoffLocation: null,
		expectedDropoffDateTime: null,
		expectedTotRentalDays: '',
		bookedCarGroup: '',
		bookedVehicleType: '',
		upSell: 'NO',
		billingCarGroup: ''
	},
	vehicleDetails: {
		acriss: null,
		sipp: null,
		plate: null,
		vehicleID: '',
		kmOnStart: '',
		tankLevelOnStart: '',
		batteryLevelOnStart: '',
		rdfiCard: '',
		eToll: '',
		chargingCableType2: '',
		chargingCableDomesticType: '',
		specialConditions: '',
		carClassDescription: '',
		carSegmentDescription: '',
		enginePowerGroupCode: null,
		keyless: '',
	},
	financialInfo: {
		creditType: '',
		paymentTiming: '',
		clientPaymentCode: '',
		driverPaymentCode: '',
		segment: '',
		category: '',
		product: '',
		paymentStatus: '',
		businessAgreement: ''
	},
	billingOwnerInfo: {
		billingOwnerActiveTab: 0,
		first: {
			person: {
				customerId: '',
				firstName: '',
				lastName: '',
				fiscalCode: '',
				gender: null,
				birthDate: null,
				birthNation: null,
				birthPlace: '',
				countryResidence: null,
				prefix: null,
				mobile: '',
				firstEmail: '',
				certifiedEmail: '',
				billingAddressGoogleSearch: '',
				billingCountry: null,
				billingProvince: null,
				billingCity: '',
				billingAddress: '',
				billingStreetNumber: '',
				billingPostalCode: '',
				drivingLicenseNumber: ''
			},
			vatNumber: {
				customerId: '',
				companyName: '',
				billingAddressGoogleSearch: '',
				billingCountry: null,
				billingProvince: null,
				billingCity: '',
				billingAddress: '',
				billingStreetNumber: '',
				billingPostalCode: '',
				firstEmail: '',
				certifiedEmail: '',
				invoiceCode: '',
				VATNumber: '',
				vatNumberCountry: null,
				legalEntity: null,
				fiscalCode: '',
				siren: '',
				siret: '',
				linkedToBa: false,
			},
			company: {
				customerId: '',
				companyName: '',
				billingAddressGoogleSearch: '',
				billingCountry: null,
				billingProvince: null,
				billingCity: '',
				billingAddress: '',
				billingStreetNumber: '',
				billingPostalCode: '',
				firstEmail: '',
				certifiedEmail: '',
				invoiceCode: '',
				VATNumber: '',
				vatNumberCountry: null,
				legalEntity: null,
				fiscalCode: '',
				siren: '',
				siret: '',
				linkedToBa: false,
				publicAuthority: null,
				paIdNumber: ''
			}
		},
		billingOwnerSecondActiveTab: 0,
		second: {
			person: {
				customerId: '',
				firstName: '',
				lastName: '',
				fiscalCode: '',
				gender: null,
				birthDate: null,
				birthNation: null,
				birthPlace: '',
				countryResidence: null,
				mobile: '',
				prefix: null,
				firstEmail: '',
				/* secondEmail: '', */
				certifiedEmail: '',
				billingAddressGoogleSearch: '',
				billingCountry: null,
				billingProvince: null,
				billingCity: '',
				billingAddress: '',
				billingStreetNumber: '',
				billingPostalCode: '',
				drivingLicenseNumber: ''
			},
			vatNumber: {
				customerId: '',
				companyName: '',
				billingAddressGoogleSearch: '',
				billingCountry: null,
				billingProvince: null,
				billingCity: '',
				billingAddress: '',
				billingStreetNumber: '',
				billingPostalCode: '',
				firstEmail: '',
				certifiedEmail: '',
				invoiceCode: '',
				VATNumber: '',
				vatNumberCountry: null,
				legalEntity: null,
				fiscalCode: '',
				siren: '',
				siret: '',
				linkedToBa: false,
			},
			company: {
				customerId: '',
				companyName: '',
				billingAddressGoogleSearch: '',
				billingCountry: null,
				billingProvince: null,
				billingCity: '',
				billingAddress: '',
				billingStreetNumber: '',
				billingPostalCode: '',
				firstEmail: '',
				certifiedEmail: '',
				invoiceCode: '',
				VATNumber: '',
				vatNumberCountry: null,
				legalEntity: null,
				fiscalCode: '',
				siren: '',
				siret: '',
				linkedToBa: false,
				publicAuthority: null,
				paIdNumber: ''
			}
		}
	},
	ancillariesInfo: {
		booked: [],
		counterSale: []
	},
	quotationInfo: {
		reservedTariffs: false,
		rate: '',
		rentalAmount: '',
		totalAncilliariesAmount: '',
		airportTax: '',
		railwayTax: '',
		roadTax: '',
		totalRentalAmountVatExcl: '',
		totalRentalAmountVatIncl: '',
		deltaDiscounts: '',
		promoRentalAmountVatIncludedTotal: '',
		netRentalAmount: '',
		damageExcess: '',
		fireTheftExcess: ''
	},
	keylessArea: {
		id: null,
		keyLessInfo: '',
		lat: null,
		lon: null,
		radius: null,
		mobilityStoreId: null
	}
}

export const PUBLIC_AUTHORITY = [{ description: "raFilling.billingOwnerInfo.form.label.no", code: "0" }, { description: "raFilling.billingOwnerInfo.form.label.yes", code: "1" }]

export enum CREDIT_TYPE_VALUES {
	PUBLIC = 'PUBLIC',
	NO_CREDIT = 'NO_CREDIT',
	PARTIAL_CREDIT = 'STANDARD_CREDIT',
	FULL_CREDIT = 'FULL_CREDIT'
}
export enum SEGMENT_VALUES {
	RETAIL = 'RET',
	SUBSCRIPTION = 'SUB',
	CORPORATE = 'COR',
	REPLACEMENT = 'REP',
	TOUR_OPERATOR = 'TOP'
}

export enum INVOICE_TYPES {
	CUSTOMER = 'CUSTOMER',
	COMPANY = 'COMPANY',
	VAT_NUMBER = 'VAT_NUMBER',
	PERSON = 'PERSON'
}

// Validation Schema
export const RA_FILLING_FORM_VALIDATION_SCHEMA = yup.object().shape({
	// generalInfo: yup.object({
	// 	pickupLocation: yup.object()
	// 		.nullable()
	// 		.required("common.error.required"),
	// 	expectedPickupDateTime: yup.date()
	// 		.nullable()
	// 		.typeError('common.error.invalidDate')
	// 		.required('common.error.required'),
	// 	dropoffLocation: yup.object()
	// 		.nullable()
	// 		.required("common.error.required"),
	// 	expectedDropoffDateTime: yup.date()
	// 		.nullable()
	// 		.typeError('common.error.invalidDate')
	// 		.required('common.error.required'),
	// 	expectedTotRentalDays: yup.string()
	// 		.required("common.error.required"),
	// 	bookedCarGroup: yup.object()
	// 		.nullable()
	// 		.required("common.error.required"),
	// 	bookedVehicleType: yup.string()
	// 		.required("common.error.required"),
	// 	upSell: yup.string()
	// 		.nullable()
	// 		.required("common.error.required")
	// }),
	vehicleDetails: yup.object({
		plate: yup.object()
			.nullable()
			.required("common.error.required"),
	}),
	// financialInfo: yup.object({
	// 	creditType: yup.object()
	// 		.nullable()
	// 		.required("common.error.required"),
	// 	paymentMethod: yup.object()
	// 		.nullable()
	// 		.required("common.error.required"),
	// 	clientPaymentCode: yup.string()
	// 		.required("common.error.required"),
	// 	driverPaymentCode: yup.string()
	// 		.required("common.error.required"),
	// 	customerCode: yup.string()
	// 		.required("common.error.required"),
	// 	segment: yup.string()
	// 		.required("common.error.required"),
	// 	category: yup.string()
	// 		.required("common.error.required"),
	// 	product: yup.string()
	// 		.required("common.error.required"),
	// }),
	// quotationInfo: yup.object({
	// 	rate: yup.string()
	// 		.required("common.error.required"),
	// 	rentalAmount: yup.string()
	// 		.required("common.error.required"),
	// 	totalAncilliariesAmount: yup.string()
	// 		.required("common.error.required"),
	// 	// airportTax: yup.string()
	// 	// 	.required("common.error.required"),
	// 	totalRentalAmountVatExcl: yup.string()
	// 		.required("common.error.required"),
	// 	totalRentalAmountVatIncl: yup.string()
	// 		.required("common.error.required"),
	// 	netRentalAmount: yup.string()
	// 		.required("common.error.required"),
	// 	damageExcess: yup.string()
	// 		.required("common.error.required"),
	// 	fireTheftExcess: yup.string()
	// 		.required("common.error.required"),
	// })
	// ,
	ancillariesInfo: yup.object({
		booked: yup.array().of(
			yup.object({
				address: yup.string().nullable()
					.test({
						name: 'address',
						message: "common.error.required",
						test(value, context) {
							return !['URBAN_DELIVERY', 'URBAN_COLLECTION', 'DELIVERY', 'COLLECTION'].includes(context.parent.subtype) || (!context.parent.units && !context.parent.mileage) || !!value;
						}
					})
			})
		),
		counterSale: yup.array().of(
			yup.object({
				address: yup.string().nullable()
					.test({
						name: 'address',
						message: "common.error.required",
						test(value, context) {
							return !['URBAN_DELIVERY', 'URBAN_COLLECTION', 'DELIVERY', 'COLLECTION'].includes(context.parent.subtype) || (!context.parent.units && !context.parent.mileage) || !!value;
						}
					})
			})
		)
	}),
	billingOwnerInfo: yup.object({
		billingOwnerActiveTab: yup.string(),
		billingOwnerSecondActiveTab: yup.string(),
		first: yup.object()
			.when('billingOwnerActiveTab', {
				is: '0',
				then: yup.object({
					person: yup.object({
						firstName: yup
							.string()
							.required('common.error.required'),
						lastName: yup
							.string()
							.required('common.error.required'),
						gender: yup
							.object()
							.nullable()
							.required('common.error.required'),
						birthDate: yup
							.date()
							.typeError('common.error.invalidDate')
							.nullable()
							.required('common.error.required'),
						birthNation: yup
							.object()
							.nullable()
							.required('common.error.required'),
						birthPlace: yup
							.string()
							.required('common.error.required'),
						countryResidence: yup
							.object()
							.nullable()
							.required('common.error.required'),
						fiscalCode: yup
							.string()
							.nullable()
							.test({
								name: 'cfNotRequired',
								message: "common.error.required",
								test(value, context) {
									return ![ITALY_CODE, SPAIN_CODE, PORTUGAL_CODE].includes(context.parent.billingCountry?.code) || !!value;
								}
							})
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === SPAIN_CODE,
								then: schema => schema.matches(FISCAL_CODE_REG_EXP_ES, {
									message: 'common.error.invalidFS',
									excludeEmptyString: true
								}),
							})
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === PORTUGAL_CODE,
								then: schema => schema.matches(FISCAL_CODE_REG_EXP_PT, {
									message: 'common.error.invalidFS',
									excludeEmptyString: true
								}),
							})
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: schema => schema.matches(FISCAL_CODE_REG_EXP, {
									message: 'common.error.invalidFS',
									excludeEmptyString: true
								}),
							}),
						// drivingLicenseNumber: yup
						// 	.string()
						// 	.required('common.error.required'),
						firstEmail: yup.string()
							.required('common.error.required')
							.email('common.error.email.isNotValid'),
						prefix: yup
							.object()
							.nullable()
							.required('common.error.required'),
						mobile: yup
							.string()
							.required('common.error.required'),
						billingCountry: yup
							.object()
							.nullable()
							.required('common.error.required'),
						billingProvince: yup
							.object()
							.nullable()
							// .required('common.error.required'),
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: (schema) => schema.required("common.error.required"),
								otherwise: (schema) => schema.notRequired(),
							}),
						billingCity: yup
							.string()
							.required('common.error.required'),
						billingAddress: yup
							.string()
							.required('common.error.required'),
						billingStreetNumber: yup
							.string()
							.required('common.error.required'),
						billingPostalCode: yup
							.string()
							.required('common.error.required')
					})
				})
			})
			.when('billingOwnerActiveTab', {
				is: '1',
				then: yup.object({
					vatNumber: yup.object({
						companyName: yup.string()
							.required('common.error.required'),
						billingCountry: yup.object()
							.nullable()
							.required('common.error.required'),
						billingProvince: yup.object()
							.nullable()
							// .required('common.error.required'),
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: (schema) => schema.required("common.error.required"),
								otherwise: (schema) => schema.notRequired(),
							}),
						billingCity: yup.string()
							.required('common.error.required'),
						billingAddress: yup.string()
							.required('common.error.required'),
						billingStreetNumber: yup.string()
							.required('common.error.required'),
						billingPostalCode: yup.string()
							.required('common.error.required'),
						firstEmail: yup.string()
							.required('common.error.required')
							.email('common.error.email.isNotValid'),
						certifiedEmail: yup.string().nullable()
							.test({
								name: 'certifiedEmail',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.invoiceCode || !!value;
								}
							})
							.test({
								name: 'certifiedEmail',
								message: "common.error.required",
								test(value, context) {
									return context.parent.billingCountry?.code !== ITALY_CODE || !!context.parent.invoiceCode || !!value;
								}
							})
							.email('common.error.email.isNotValid'),
						invoiceCode: yup.string() // if invoice cert Email is empty
							.test({
								name: 'invoiceCode',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.certifiedEmail || !!value;
								}
							})
							.test({
								name: 'invoiceCode',
								message: "common.error.required",
								test(value, context) {
									return context.parent.billingCountry?.code !== ITALY_CODE || !!context.parent.certifiedEmail || !!value;
								}
							}),
						VATNumber: yup.string()
							.required('common.error.required'),
						vatNumberCountry: yup.object()
							.nullable()
							.required('common.error.required'),
						siren: yup.string()
							.nullable()
							.test({
								name: 'sirenNotRequired',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== FRANCE_CODE || !!value;
								}
							}),
						legalEntity: yup.object().required('common.error.required'),
						fiscalCode: yup
							.string()
							.nullable()
							.test({
								name: 'cfNotRequired',
								message: "common.error.required",
								test(value, context) {
									return ![ITALY_CODE, SPAIN_CODE, PORTUGAL_CODE].includes(context.parent.billingCountry?.code) || !!value;
								}
							})

					})
				})
			})
			.when('billingOwnerActiveTab', {
				is: '2',
				then: yup.object({
					company: yup.object({
						companyName: yup.string()
							.required('common.error.required'),
						billingCountry: yup.object()
							.nullable()
							.required('common.error.required'),
						billingProvince: yup.object()
							.nullable()
							// .required('common.error.required'),
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: (schema) => schema.required("common.error.required"),
								otherwise: (schema) => schema.notRequired(),
							}),
						billingCity: yup.string()
							.required('common.error.required'),
						billingAddress: yup.string()
							.required('common.error.required'),
						billingStreetNumber: yup.string()
							.required('common.error.required'),
						billingPostalCode: yup.string()
							.required('common.error.required'),
						firstEmail: yup.string()
							.required('common.error.required')
							.email('common.error.email.isNotValid'),
						certifiedEmail: yup.string().nullable()
							.test({
								name: 'certifiedEmail',
								message: "common.error.required",
								test(value, context) {
									const publicAuthority = context.parent.publicAuthority;
									if (publicAuthority?.code === '1') {
										return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.paIdNumber || !!value;
									} else {
										return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.invoiceCode || !!value;
									}
								}
							})
							.email('common.error.email.isNotValid'),
						invoiceCode: yup.string() // if invoice cert Email is empty
							.test({
								name: 'invoiceCode',
								message: "common.error.required",
								test(value, context) {
									const publicAuthority = context.parent.publicAuthority;
									if (context.parent.vatNumberCountry?.code === ITALY_CODE && publicAuthority?.code != '1') {
										return !!context.parent.certifiedEmail || !!value;
									} else return true;
								}
							}),
						paIdNumber: yup.string() // if paIdNumber cert Email is empty
							.test({
								name: 'paIdNumber',
								message: "common.error.required",
								test(value, context) {
									const publicAuthority = context.parent.publicAuthority;
									if (publicAuthority?.code === '1') {
										return !!context.parent.certifiedEmail || !!value;
									} else return true;
								}
							}),
						VATNumber: yup.string()
							.when('legalEntity', (legalEntity, field) => {
								if (getRequiredVatNr(legalEntity?.code)) {
									return field.required('common.error.required')
								}
								return field
							}),
						vatNumberCountry: yup.object()
							.nullable()
							.when('legalEntity', (legalEntity, field) => {
								if (getRequiredVatNr(legalEntity?.code)) {
									return field.required('common.error.required')
								}
								return field
							}),
						siren: yup.string()
							.nullable()
							.test({
								name: 'sirenNotRequired',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== FRANCE_CODE || !getRequiredVatNr(context.parent.legalEntity?.code) || !!value;
								}
							}),
						legalEntity: yup.object().required('common.error.required'),
						fiscalCode: yup
							.string()
							.nullable()
							.test({
								name: 'cfNotRequired',
								message: "common.error.required",
								test(value, context) {
									return ![ITALY_CODE, SPAIN_CODE, PORTUGAL_CODE].includes(context.parent.billingCountry?.code) || !!value;
								}
							})

					})
				})
			}),
		second: yup.object()
			.when('billingOwnerSecondActiveTab', {
				is: '0',
				then: yup.object({
					person: yup.object({
						firstName: yup
							.string()
							.required('common.error.required'),
						lastName: yup
							.string()
							.required('common.error.required'),
						gender: yup
							.object()
							.nullable()
							.required('common.error.required'),
						birthDate: yup
							.date()
							.typeError('common.error.invalidDate')
							.nullable()
							.required('common.error.required'),
						birthNation: yup
							.object()
							.nullable()
							.required('common.error.required'),
						birthPlace: yup
							.string()
							.required('common.error.required'),
						countryResidence: yup
							.object()
							.nullable()
							.required('common.error.required'),
						fiscalCode: yup
							.string()
							.nullable()
							.test({
								name: 'cfNotRequired',
								message: "common.error.required",
								test(value, context) {
									return ![ITALY_CODE, SPAIN_CODE, PORTUGAL_CODE].includes(context.parent.billingCountry?.code) || !!value;
								}
							})
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === SPAIN_CODE,
								then: schema => schema.matches(FISCAL_CODE_REG_EXP_ES, {
									message: 'common.error.invalidFS',
									excludeEmptyString: true
								}),
							})
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === PORTUGAL_CODE,
								then: schema => schema.matches(FISCAL_CODE_REG_EXP_PT, {
									message: 'common.error.invalidFS',
									excludeEmptyString: true
								}),
							})
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: schema => schema.matches(FISCAL_CODE_REG_EXP, {
									message: 'common.error.invalidFS',
									excludeEmptyString: true
								}),
							}),
						// drivingLicenseNumber: yup
						// 	.string()
						// 	.required('common.error.required'),
						firstEmail: yup.string()
							.required('common.error.required')
							.email('common.error.email.isNotValid'),
						prefix: yup
							.object()
							.nullable()
							.required('common.error.required'),
						mobile: yup
							.string()
							.required('common.error.required'),
						billingCountry: yup
							.object()
							.nullable()
							.required('common.error.required'),
						billingProvince: yup
							.object()
							.nullable()
							// .required('common.error.required'),
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: (schema) => schema.required("common.error.required"),
								otherwise: (schema) => schema.notRequired(),
							}),
						billingCity: yup
							.string()
							.required('common.error.required'),
						billingAddress: yup
							.string()
							.required('common.error.required'),
						billingStreetNumber: yup
							.string()
							.required('common.error.required'),
						billingPostalCode: yup
							.string()
							.required('common.error.required')
					})
				})
			})
			.when('billingOwnerSecondActiveTab', {
				is: '1',
				then: yup.object({
					vatNumber: yup.object({
						companyName: yup.string()
							.required('common.error.required'),
						billingCountry: yup.object()
							.nullable()
							.required('common.error.required'),
						billingProvince: yup.object()
							.nullable()
							// .required('common.error.required'),
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: (schema) => schema.required("common.error.required"),
								otherwise: (schema) => schema.notRequired(),
							}),
						billingCity: yup.string()
							.required('common.error.required'),
						billingAddress: yup.string()
							.required('common.error.required'),
						billingStreetNumber: yup.string()
							.required('common.error.required'),
						billingPostalCode: yup.string()
							.required('common.error.required'),
						firstEmail: yup.string()
							.required('common.error.required')
							.email('common.error.email.isNotValid'),
						certifiedEmail: yup.string().nullable()
							.test({
								name: 'certifiedEmail',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.invoiceCode || !!value;
								}
							})
							.test({
								name: 'certifiedEmail',
								message: "common.error.required",
								test(value, context) {
									return context.parent.billingCountry?.code !== ITALY_CODE || !!context.parent.invoiceCode || !!value;
								}
							})
							.email('common.error.email.isNotValid'),
						invoiceCode: yup.string() // if invoice cert Email is empty
							.test({
								name: 'invoiceCode',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.certifiedEmail || !!value;
								}
							}),
						VATNumber: yup.string()
							.required('common.error.required')
							.test({
								name: 'vatNr',
								message: 'common.error.vatNumber',
								test(value, context) {
									return validateVatNr(value || '', context.parent?.vatNumberCountry?.code)
								}
							}),
						vatNumberCountry: yup.object()
							.nullable()
							.required('common.error.required'),
						siren: yup.string()
							.nullable()
							.test({
								name: 'sirenNotRequired',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== FRANCE_CODE || !!value;
								}
							}),
						legalEntity: yup.object().required('common.error.required'),
						fiscalCode: yup
							.string()
							.nullable()
							.test({
								name: 'cfNotRequired',
								message: "common.error.required",
								test(value, context) {
									return ![ITALY_CODE, SPAIN_CODE, PORTUGAL_CODE].includes(context.parent.billingCountry?.code) || !!value;
								}
							})

					})
				})
			})
			.when('billingOwnerSecondActiveTab', {
				is: '2',
				then: yup.object({
					company: yup.object({
						companyName: yup.string()
							.required('common.error.required'),
						billingCountry: yup.object()
							.nullable()
							.required('common.error.required'),
						billingProvince: yup.object()
							.nullable()
							// .required('common.error.required'),
							.when('billingCountry', {
								is: (billingCountry: any) => billingCountry?.code === ITALY_CODE,
								then: (schema) => schema.required("common.error.required"),
								otherwise: (schema) => schema.notRequired(),
							}),
						billingCity: yup.string()
							.required('common.error.required'),
						billingAddress: yup.string()
							.required('common.error.required'),
						billingStreetNumber: yup.string()
							.required('common.error.required'),
						billingPostalCode: yup.string()
							.required('common.error.required'),
						firstEmail: yup.string()
							.required('common.error.required')
							.email('common.error.email.isNotValid'),
						certifiedEmail: yup.string().nullable()
							.test({
								name: 'certifiedEmail',
								message: "common.error.required",
								test(value, context) {
									const publicAuthority = context.parent.publicAuthority;
									if (publicAuthority?.code === '1') {
										return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.paIdNumber || !!value;
									} else {
										return context.parent.vatNumberCountry?.code !== ITALY_CODE || !!context.parent.invoiceCode || !!value;
									}
								}
							})
							.email('common.error.email.isNotValid'),
						invoiceCode: yup.string() // if invoice cert Email is empty
							.test({
								name: 'invoiceCode',
								message: "common.error.required",
								test(value, context) {
									const publicAuthority = context.parent.publicAuthority;
									if (context.parent.vatNumberCountry?.code === ITALY_CODE && publicAuthority?.code !== '1') {
										return !!context.parent.certifiedEmail || !!value;
									} else return true;
								}
							}),
						paIdNumber: yup.string() // if paIdNumber cert Email is empty
							.test({
								name: 'paIdNumber',
								message: "common.error.required",
								test(value, context) {
									const publicAuthority = context.parent.publicAuthority;
									if (publicAuthority?.code === '1') {
										return !!context.parent.certifiedEmail || !!value;
									} else return true;
								}
							}),
						VATNumber: yup.string()
							.when('legalEntity', (legalEntity, field) => {
								if (getRequiredVatNr(legalEntity?.code)) {
									return field.required('common.error.required')
								}
								return field
							}),
						vatNumberCountry: yup.object()
							.nullable()
							.when('legalEntity', (legalEntity, field) => {
								if (getRequiredVatNr(legalEntity?.code)) {
									return field.required('common.error.required')
								}
								return field;
							}),
						siren: yup.string()
							.nullable()
							.test({
								name: 'sirenNotRequired',
								message: "common.error.required",
								test(value, context) {
									return context.parent.vatNumberCountry?.code !== FRANCE_CODE || !getRequiredVatNr(context.parent.legalEntity?.code) || !!value;
								}
							}),
						legalEntity: yup.object().required('common.error.required'),
						fiscalCode: yup
							.string()
							.nullable()
							.test({
								name: 'cfNotRequired',
								message: "common.error.required",
								test(value, context) {
									return ![ITALY_CODE, SPAIN_CODE, PORTUGAL_CODE].includes(context.parent.billingCountry?.code) || !!value;
								}
							})
					})
				})
			})
	}),
});

// Validation Schema Keyless
export const RA_FILLING_FORM_VALIDATION_SCHEMA_KEYLESS = RA_FILLING_FORM_VALIDATION_SCHEMA.shape({
	keylessArea: yup
		.object()
		.nullable()
		.required("common.error.required")
		.test(
			"not-empty",
			"common.error.required",
			value => {
				if (!value) return false;
				return Object.values(value).some(v => v !== null && v !== "");
			}),
});

export const DEFAULT_BO_FIELDS_STATE_VALUES = {
	person: {
		firstName: false,
		lastName: false,
		fiscalCode: false,
		gender: false,
		birthDate: false,
		birthNation: false,
		birthPlace: false,
		countryResidence: false,
		prefix: false,
		mobile: false,
		firstEmail: false,
		certifiedEmail: false,
		billingAddressGoogleSearch: false,
		billingCountry: false,
		billingProvince: false,
		billingCity: false,
		billingAddress: false,
		billingStreetNumber: false,
		billingPostalCode: false,
		drivingLicenseNumber: false
	},
	company: {
		companyName: false,
		legalEntity: false,
		publicAuthority: false,
		vatNumberCountry: false,
		VATNumber: false,
		fiscalCode: false,
		billingAddressGoogleSearch: false,
		billingCountry: false,
		billingProvince: false,
		billingCity: false,
		billingAddress: false,
		billingStreetNumber: false,
		billingPostalCode: false,
		firstEmail: false,
		certifiedEmail: false,
		paIdNumber: false,
		invoiceCode: false
	}
};

export interface RaFillingAccordionValidation {
	[key: string]: boolean,
	generalInfo: boolean,
	firstBillingOwnerInfo: boolean,
	secondBillingOwnerInfo: boolean,
	ancillariesInfo: boolean
}